import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper'
import {useAdjustment} from './AdjustmentsContent-hook'

export const AdjustmentsContent = ({adjustmentsData}) => {
  const {adjustmentsJsonSchema, adjustmentsUISchema} = useAdjustment()
  const getVal = v => v || '-'
  return (
    <div>
      <JsonFormsWrapper
        jsonschema={adjustmentsJsonSchema}
        uischema={adjustmentsUISchema}
        data={{
          adjustmentType: getVal(adjustmentsData?.adjustmentType),
          reasonCode: getVal(adjustmentsData?.reasonCode),
          quantity: getVal(adjustmentsData?.quantity),
        }}
      />
    </div>
  )
}
